import Super from 'client-portal/routes/-request/location';
import classic from 'ember-classic-decorator';

@classic
export default class WidgetLocation extends Super {}
